export interface AusmitError {
	headers?: object;
	status: number;
	statusText?: string
	name?: string;
	message?: string;
	error: {
		error: {
			message: string;
		}
		isFailed?: string;
	}
}
